import { motion } from "framer-motion";
import { useSite } from "@/context/SiteContext";
import { WhatsAppIcon } from "./Contact";

export const FloatingWhatsApp = () => {
  const { content, lang } = useSite();
  const num = (content?.contact?.whatsapp || "").replace(/\D/g, "");
  if (!num) return null;

  const msg = lang === "zh" ? "您好，我想咨询保险服务" : "Hi, I'd like to ask about insurance plans";

  return (
    <motion.a
      data-testid="floating-whatsapp"
      href={`https://wa.me/${num}?text=${encodeURIComponent(msg)}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.4, type: "spring", stiffness: 260, damping: 18 }}
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 inline-flex rounded-full bg-[#25D366] opacity-40 animate-ping" />
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_8px_24px_rgba(37,211,102,0.45)] group-hover:scale-110 transition-transform duration-300">
        <WhatsAppIcon size={28} />
      </span>
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-slate-900 text-white text-xs font-bold px-3.5 py-2 opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-[opacity,transform] duration-300 pointer-events-none">
        {lang === "zh" ? "WhatsApp 在线咨询" : "Chat on WhatsApp"}
      </span>
    </motion.a>
  );
};
